"use strict";

import $ from "jquery";


// const filterInputs = function () {
//   const form = $("#card-forms-wrapper form");
//   const type = "." + $("#card_card_type").val();
//   form.find(".filterable").closest(".form-group").hide();
//   form.find(`.filterable${type}`).closest(".form-group").show();
// };

$(document).on("turbolinks:load", function () {
  const manual_checkbox = $("#card_form_manual_preview");
  const manual_preview  = $("#card_form_preview_content");
  if (manual_checkbox.length == 0 || manual_preview.length == 0) {
    return;
  }

  const togglePreviewContent = function () {
    const manual = !!manual_checkbox.prop("checked");
    manual_preview.prop("disabled", !manual);
  };

  // function toggleFileField(){
  //   var chart_template_type = $("#card_chart_attributes_chart_template_type").val().toLowerCase();
  //   if ($("#card_card_type").val() == "chart" && (chart_template_type != ("octopuscharts" || "spotchartdefinitions" || "spotchartindustry" ))) {
  //     $("#chart_resource_file_row").removeClass("hidden");
  //   }else if (chart_template_type == "octopuschart" && $("#edit_octopus_chart_form").length == 0){
  //     $.get("/cards/octopus_chart");
  //     $("#chart_resource_file_row").addClass("hidden");
  //   }else if (chart_template_type == ("spotchartdefinitions" || "spotchartindustry") && $("#edit_spot_chart_spot_form").length == 0){
  //     $.get("/cards/spot_chart_spot");
  //     $("#chart_resource_file_row").addClass("hidden");
  //   }else{
  //     $("#chart_resource_file_row").addClass("hidden");
  //     $("#octopus_chart_form").empty();
  //   }
  //   return true;
  // }
  // function showHideFields(){
  //   toggleFileField();
  //   // filterInputs();
  // }
  // $("#card_card_type").on("change", showHideFields);

  // $( document ).ready(function() {
  //   showHideFields();
  // });

  manual_checkbox.on("change", togglePreviewContent);

  togglePreviewContent();
});
